import { key, notify } from '@databases/ping-registry';
import { createCheckboxEffect } from '@databases/selections';
import { type DatabaseAdapter } from '@databases/selections-api-types';

import {
  type SelectionEffectFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export function createCheckboxEffectFeature(deps: {
  databaseAdapter: DatabaseAdapter;
}): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.CHECKBOX_EFFECT,
    type: 'effect',
    // Always active when mode includes it — checkbox visibility
    // is read-only UI that doesn't require edit permissions.s
    factory: () =>
      createCheckboxEffect({
        databaseAdapter: deps.databaseAdapter,
        notifyRowSelected: (entryId: string, selected: boolean) => {
          const rowKey = key('row', { entryId });

          notify(rowKey, 'selected', selected);
        },
        notifyHeaderCheckboxState: (state) => {
          const headerKey = key('headerCheckbox', {});

          notify(headerKey, 'state', state);
        },
      }),
  };
}
